import apiClient from '@/services/axios';

export async function get(venueId) {
  var response = await apiClient.get(`/ActivationPlanBudgets/${venueId}/0505/05`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get activation plan budget')
}